const s = {
  rum: {
    posthogId: "phc_nkrGlLIrq0Aa83FGyO7M0ydNfFikBeydgPfMbgfuYr1",
    host: "https://eu.posthog.com"
  },
  chat: {
    // src: "https://chat-assets.frontapp.com/v1/chat.bundle.js"
    host: ""
  },
  googleTagManager: {
    src: "https://www.googletagmanager.com/gtag/js?id=AW-10965529593",
    id: "gtag-ad"
  }
}, t = {
  host: "typesense.mailslurp.biz",
  port: 443,
  protocol: "https",
  apiKey: "PCdZ5kOKYem3BN4EmygsQUsK9tKRgcCQ",
  apiKeyParam: "x-typesense-api-key",
  collectionName: "mailslurp",
  indexName: "mailslurp"
}, p = {
  facebook: "https://www.facebook.com/people/MailSlurp/100093660243614/",
  medium: "https://medium.com/@mailslurp",
  twitter: "https://twitter.com/mailslurp",
  github: "https://github.com/mailslurp",
  linkedin: "https://www.linkedin.com/company/mailslurpdev/",
  youtube: "https://youtube.com/@mailslurp",
  instagram: "https://www.instagram.com/mailslurp/",
  devto: "https://dev.to/mailslurp",
  postman: "https://www.postman.com/mailslurp-api"
}, a = {
  support: {
    url: "https://www.mailslurp.com/support/",
    email: "support@mailslurp.dev",
    calendar: "https://meetings.hubspot.com/contact2328"
  },
  sales: {
    url: "https://www.mailslurp.com/sales/",
    email: "jack@mailslurp.dev",
    calendar: "https://meetings.hubspot.com/contact2328"
  },
  examples: "https://docs.mailslurp.com/examples/",
  guides: "https://www.mailslurp.com/guides/",
  docs: {
    index: "https://docs.mailslurp.com",
    sdks: "https://docs.mailslurp.com/",
    swaggerUi: "https://api.mailslurp.com/swagger-ui/index.html"
  },
  sdks: {
    index: "https://docs.mailslurp.com/",
    swagger: "https://www.postman.com/mailslurp-api",
    postman: "https://www.postman.com/mailslurp-api",
    api: "https://docs.mailslurp.com/api/",
    // sdks
    go: {
      docs: "https://docs.mailslurp.com/go/",
      methods: "https://go.mailslurp.com/",
      package: "https://github.com/mailslurp/mailslurp-client-go.git"
    },
    javascript: {
      docs: "https://docs.mailslurp.com/js/",
      // methods: "https://js.mailslurp.com/",
      package: "https://www.npmjs.com/package/mailslurp-client"
    },
    csharp: {
      docs: "https://docs.mailslurp.com/csharp/",
      methods: "https://csharp.mailslurp.com/",
      package: "https://www.nuget.org/packages/mailslurp/"
    },
    java: {
      docs: "https://docs.mailslurp.com/java/",
      methods: "https://java.mailslurp.com",
      package: "https://mailslurp.github.io/mailslurp-client-java/"
    }
  },
  legal: {
    privacy: "https://www.mailslurp.com/privacy-policy/",
    terms: "https://www.mailslurp.com/full-terms-and-conditions/",
    cookiePolicy: "https://www.mailslurp.com/cookie-policy/"
  }
};
export {
  a as links,
  t as search,
  p as social,
  s as tags
};
